import cookie from 'js-cookie'
import store from '../store'
import "../api/plugins/axios"
import User from "../api/scm/user/user"
import Dict from "../api/scm/base/dictionary.js"
import Org from "../api/scm/org/org.js";
import Inventory from "../api/scm/inventory/inventory.js";

const userObj = new User();
const dictObj = new Dict();
const orgObj = new Org();
const inventoryObj = new Inventory();


// 时间戳转化为2023-03-03 12:12:12 这样的格式
function formatToTime(time) {
    var date = new Date(time * 1000); // 传入的时间单位是秒，需要转化为毫秒
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); //2位不够补0
    const day = date.getDate().toString().padStart(2, '0');
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
    const second = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}

//将开始-结束时间选择组件产生的时间数组中，各元素的时间格式处理成YYYY-MM-DD的字符串数组
function setStartEndDate(val) {
    //val确保包含了2个元素（开始、结束）
    if (val.length === 2) {
        let temp = [];
        for (let i = 0; i < val.length; i++) {
            let date = new Date(val[i]);
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');
            let myDay = year + '-' + month + '-' + day;
            temp.push(myDay);
        }
        return temp;
    }
}


//获取当前日期，返回YYYY-MM-DD字符串。
function getCurrentDate() {
    let currentDate = new Date();
    // 获取年份  
    let year = currentDate.getFullYear();
    // 获取月份（注意月份是从0开始的，所以需要+1，并且可能需要补零）  
    let month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    // 获取日期（并且可能需要补零）  
    let day = currentDate.getDate().toString().padStart(2, '0');
    // 拼接成"YYYY-MM-DD"格式的字符串  
    let formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
}


// 接口所需要的请求体
function setBody(id, token, offset, limit, query_name) {
    let body = {
        types: "object,object",
        values: [{
                offset: offset,
                limit: limit,
                query_name: query_name
            },
            {
                token: token,
                uid: id
            },
        ]
    };
    return body
}

// cookie存储数据
function setCookieParam(res) {
    let expires = res.cookie.expires + 's';
    //let token = res.cookie.token;
    return [token, expires]
}

// 通过store缓存获取用户菜单权限,缓存失效，重新赋值
async function getMenuAuthByCache(uid) {
    let menu = [];
    menu = store.state.menuAuth;
    // console.log('utils menu ', menu);
    // store缓存失效，重新赋值
    if (typeof menu === 'undefined' || menu.length === 0) {
        //let user = cookie.get('identity');
        let user = localStorage.getItem("userIdentity");
        console.log('重新获取的用户类型是：', user);
        if (user === 'user') {
            let body = uid;
            const res1 = await userObj.getMenuAuthority(body);
            menu = await JSON.parse(JSON.stringify(res1.module_infos));
            store.commit('setMenu', menu);
            // console.log('store重新存储menu', menu);

            // 本地存储menu
            // menu = JSON.parse(sessionStorage.getItem('menu'));
            // console.log('menuInSession', menu);
            // console.log('拿出store的menu', store.state.menuAuth);
            // return menu
        } else if (user === 'supplier_user') {
            // console.log('重新获取的token',cookie.get('token'))
            // console.log('重新获取的uid', Number(uid))
            let body2 = uid;
            const res2 = await userObj.getSupMenuAuthority(body2);
            menu = await JSON.parse(JSON.stringify(res2.module_infos));
            // console.log('重新获取的sup_menu', JSON.stringify(res2.module_infos));
            store.commit('setMenu', menu);
        } else {
            console.log('重新获取用户权限失败')
        }

    } else if (menu.length > 0) {
        // console.log('menuInStore', menu);
        // return menu
    } else {
        console.log('menu获取失败');
    }
    // console.log('最终返回的menu', menu); //是个array
    // console.log('menu的类型', typeof menu); // object
    return menu
}

/*输入当前路由path,输入从接口获得的用户菜单信息，获得对应的authority信息
path：需要提取的路由信息，source：整个菜单权限数组module_infos
示例：
path：/h/3/list
module_infos": [
            {
                "icon": string,
                "label": string,
                "children": [
                    {
                        "authority": [
                        1,
                        2,
                        3,
                        4
                    ],
                        "icon": string,
                        "label": string,
                        "name": string,
                        "path": string
                    },
                    {
                        ....
                    }
                ]

            },

*/
// function getMenuAuthorityByPath(path, source) {
async function getMenuAuthorityByPath(path, uid) {
    let source = [];
    source = await this.getMenuAuthByCache(uid);
    let res = []; //结果返回的变量申明
    for (let i = 0; i < source.length; i++) {
        for (let j = 0; j < source[i].children.length; j++) {
            let pathString = source[i].children[j].path;
            //pathString的格式"/一级模块名称/用户id/菜单名称"
            if (path === pathString) {
                res = source[i].children[j].authority;
            }
        }
    }
    if (res.length === 0) { //没找到对应的模块、菜单信息
        console.log("未找到匹配的模块或菜单权限");
    }
    return res; //返回authority数组：[1,2,3,4]
}

/*权限格式调整，将[1,2,3,4],转换成按钮可用的格式，
适用于不需要plus、remove的按钮。
上传下载功能未开放，因此也默认false。待开放后，再更新。
传入参数arr，格式为数组，示例：[1,2,3,4]，其中1=增，2=删，3=改，4=查
返回一个res对象
*/
function perms2BtnAuth(arr) {
    //初始化设置默认值
    let res = {
        add: false,
        edit: false,
        read: false,
        delete: false,
        plus: false,
        remove: false,
        disable: false,
        enable: false,
        upload: false,
        download: false,
        file_upload: false,
        file_download: false,
        approval: false,
        import: false,
    };
    for (let i = 0; i < arr.length; i++) {
        switch (arr[i]) {
            case 1:
                res.add = true;
                break;
            case 2:
                res.delete = true;
                break;
            case 3:
                res.edit = true;
                break;
            case 4:
                res.read = false; //查看不通过按钮，保持禁用
                break;
            case 5:
                res.disable = true;
                break;
            case 6:
                res.download = true;
                break;
            case 7:
                res.import = true;
                break;
            case 0:
                //是管理员账号的权限，默认给启用、禁用的按钮。
                res.disable = true;
                res.enable = true;
                break;
        }
    }
    return res;
}

//在arr中，查找元素对象的field字段，是否与id的值相同，若相同，返回其在arr数组中的index。
function getIndexById(id, arr, field) {
    if (arr.length === 0) { //检查数组是否为空
        console.log("Array is empty");
        return false;
    } else {
        let index_num = -1;
        let cnt = 0; //检查数组中是否有多个相同的id
        arr.forEach((v, index) => {
            if (v[field] === id) {
                cnt = cnt + 1
                index_num = index;
            }
        });
        if (cnt === 1 && index_num !== -1) { //如果有且仅有1个，做返回
            return index_num;
        } else {
            console.log("id is not found or more than one id found");
            return false;
        }
    }
}


//获取uid和cookie的token
function getUidAndToken(route) {
    let res = {};
    res.token = cookie.get("token");
    res.uid = Number(route.params.id);
    return res;
}

//根据route获取用户在当前页面的权限数组
async function getAuthorityByRoute(route) {
    let uid = Number(route.params.id);
    let path = route.path;
    let source = [];
    source = await this.getMenuAuthByCache(uid);
    let res = []; //结果返回的变量申明
    for (let i = 0; i < source.length; i++) {
        for (let j = 0; j < source[i].children.length; j++) {
            let pathString = source[i].children[j].path;
            //pathString的格式"/一级模块名称/用户id/菜单名称"
            if (path === pathString) {
                res = source[i].children[j].authority;
            }
        }
    }
    if (res.length === 0) { //没找到对应的模块、菜单信息
        console.log("未找到匹配的模块或菜单权限");
    }
    if (uid === 1) {
        //超级管理员，添加0
        res.push(0);
    }
    return res; //返回authority数组：[1,2,3,4]，如果是管理员角色，多一个0
}

//检查对象中，按照fields的字段，是否都有定义且不为空。
function isObjComplete(fields, obj) {
    let res = true;
    for (let i = 0; i < fields.length; i++) {
        let value = obj[fields[i]];
        if (value === null || value === undefined || value === "" || Array.isArray(value) && value.length === 0 || typeof value === "object" && Object.keys(value).length === 0) {
            res = false;
        }
    }
    return res;
}

/*输入数量n、采购视图pObj。计算输出该数量是否满足如下所有条件：
1、大于采购视图中的最小起订量。
其中，n是采购订单中“按采购单位”的数量。
计算结果，对外返回一个对象：{result:Boolean, info:string}。result存放检查结果，info存放检查信息
*/
function checkPurchaseQty(n, pObj) {
    //获取单位转换信息
    let ratio = pObj.uom_conversion_rule;
    //获取采购视图中的最小起订量信息
    let min_order_qty = pObj.min_order_qty;
    //判断n是否大于等于最小起订量
    if (n < min_order_qty) { //n<最小起订量
        return { result: false, info: "采购数量应当大于最小起订量：" + min_order_qty };
    }
    /*判断n是否满足最小包装数的倍数
    //获取物流视图中的最小包装数信息
    let min_qty_per_package = lObj.min_qty_per_package;
    if (min_qty_per_package !== 0) {
        //先将单位统一到基本单位
        let new_n = n * ratio;
        let res = new_n % min_qty_per_package;
        if (res !== 0) {//不是整数倍
            return { result: false, info: "采购数量应当是最小包装数(" + min_qty_per_package + ")的倍数" };
        }
    } else {
        throw new Error("Min qty per package can not be ZERO,最小包装数不能是0");
    }
    return { result: true, info: "采购数量大于最小起订量且符合最小包装数的倍数" };
    */
    return { result: true, info: "采购数量大于最小起订量" };
}

/*输入数量n、销售视图sObj。计算输出该数量是否满足如下所有条件：
1、大于销售视图中的最小起售量。
2、是销售视图中，最小包装数的倍数。
其中，n是销售订单中“按销售单位”的数量。
计算结果，对外返回一个对象：{result:Boolean, info:string}。result存放检查结果，info存放检查信息
*/
function checkSaleQty(n, sObj) {
    //获取单位转换信息
    let ratio = sObj.uom_conversion_rule;
    //获取销售视图中的最小起售量信息
    let min_order_qty = sObj.min_order_qty;
    //判断n是否大于等于最小起订量
    if (n < min_order_qty) { //小于最小起订量
        return { result: false, info: "销售数量应当大于最小起售量：" + min_order_qty };
    }
    //判断n是否满足最小包装数的倍数
    //获取销售视图中的最小包装数信息
    let min_qty_per_package = sObj.min_qty_per_package;
    if (min_qty_per_package !== 0) {
        //先将单位统一到基本单位
        let new_n = n * ratio;
        console.log("数量转换", new_n);
        let res = new_n % min_qty_per_package;
        if (res !== 0) { //不是整数倍
            return { result: false, info: "销售数量应当是最小包装数(" + min_qty_per_package + ")的倍数" };
        }
    } else {
        throw new Error("Min qty per package can not be ZERO,最小包装数不能是0");
    }
    return { result: true, info: "销售数量大于最小起订量且符合最小包装数的倍数" };

}

//计算val的字符串日期，是否等于晚于当天，如果等于晚于，返回true，否则返回false
function afterToday(val) {
    //取当前日期时间，转成字符串，用于去掉具体的时间。
    let d0 = new Date();
    let year = d0.getFullYear();
    let month = (d0.getMonth() + 1).toString().padStart(2, '0');
    let day = d0.getDate().toString().padStart(2, '0');
    let d1 = year + '-' + month + '-' + day;
    //将不带时间的字符串"YYYY-MM-DD"，转成日期类型
    let d2 = new Date(d1);
    //将传入的字符串，转成日期类型
    let d3 = new Date(val);
    if (d3 >= d2) {
        //console.log("输入的"+val+"晚于等于今天");
        return true;
    } else {
        return false;
    }
}

//当前日期经过X天，是否超过date的日期，date是字符串
function isAfterXDays(x, date) {
    //取当前日期时间，转成字符串，用于去掉具体的时间。
    let d0 = new Date();
    let year = d0.getFullYear();
    let month = (d0.getMonth() + 1).toString().padStart(2, '0');
    let day = d0.getDate().toString().padStart(2, '0');
    let d1 = year + '-' + month + '-' + day;
    //将不带时间的字符串"YYYY-MM-DD"，转成日期类型
    let d2 = new Date(d1);
    //当前日期的基础上，增加x天
    let d3 = d2.setDate(d2.getDate() + x);
    //将传入的字符串，转成日期类型
    let d4 = new Date(date);
    //比较d3是否超过了d4
    if (d3 > d4) {
        //当前日期+X天，超过了date
        return true;
    } else {
        //当前日期+X天，没有超过date
        return false;
    }
}


//--------------------------四则运算函数---------------------------//
/**
 ** 加法函数，用来得到精确的加法结果
 ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
 ** 调用：accAdd(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
function accAdd(arg1, arg2) {
    var r1, r2, m, c;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    c = Math.abs(r1 - r2);
    m = Math.pow(10, Math.max(r1, r2));
    if (c > 0) {
        var cm = Math.pow(10, c);
        if (r1 > r2) {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", "")) * cm;
        } else {
            arg1 = Number(arg1.toString().replace(".", "")) * cm;
            arg2 = Number(arg2.toString().replace(".", ""));
        }
    } else {
        arg1 = Number(arg1.toString().replace(".", ""));
        arg2 = Number(arg2.toString().replace(".", ""));
    }
    return (arg1 + arg2) / m;
}

/**
 ** 减法函数，用来得到精确的减法结果
 ** 说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
 ** 调用：accSub(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
function accSub(arg1, arg2) {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

/**
 ** 乘法函数，用来得到精确的乘法结果
 ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 ** 调用：accMul(arg1,arg2)
 ** 返回值：arg1乘以 arg2的精确结果
 **/
function accMul(arg1, arg2) {
    var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length;
    } catch (e) {}
    try {
        m += s2.split(".")[1].length;
    } catch (e) {}
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}

/** 
 ** 除法函数，用来得到精确的除法结果
 ** 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
 ** 调用：accDiv(arg1,arg2)
 ** 返回值：arg1除以arg2的精确结果
 **/
function accDiv(arg1, arg2) {
    var t1 = 0,
        t2 = 0,
        r1, r2;
    try {
        t1 = arg1.toString().split(".")[1].length;
    } catch (e) {}
    try {
        t2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        // 如果arg2不是数字或没有小数部分，t2保持为0  
    }
    // 直接调用Math.pow而不是使用with语句  
    r1 = Number(arg1.toString().replace(".", ""));
    r2 = Number(arg2.toString().replace(".", ""));
    return (r1 / r2) * Math.pow(10, t2 - t1);
}

/*arr是待检查的对象数组，str待检查数组中每个对象的某个属性名称。
如有相同的，返回true，无相同的，返回false
*/
function hasDuplicatedStr(arr, str) {
    let seenValues = new Set();
    for (let obj of arr) {
        if (obj.hasOwnProperty(str)) {
            let value = obj[str];
            if (seenValues.has(value)) {
                return true; // 发现重复值
            }
            seenValues.add(value);
        }
    }
    return false; // 没有发现重复值
}


//在根库位列表中，按照factory_id，找到对应的factory_name，用factory_name+full_name，拼成一个新的full_path，用于显示
//在a中取factory_id，在b中进行查找获取company_factory_name，和a中的full_name拼成一个新的full_path
function lookupComapnyFactory(a, b) {
    //对数组b创建映射
    let factoryMap = b.reduce((map, factory) => {
        map[factory.id] = factory.factory_name;
        return map;
    }, {});
    a.forEach(item => {
        let factoryId = item.factory_id;
        let factoryName = factoryMap[factoryId];
        if (factoryName) {
            item.full_path = `${factoryName}/${item.full_name}`;
        }
    });
    return a;
}

//税后单价更新
function updateUnitPriceInclueTax(unit_price, tax_rate) {
    //a1=1+税率的值%
    let a1 = this.accAdd(1, this.accDiv(tax_rate, 100));
    //a2=a1*单价
    let a2 = this.accMul(a1, unit_price);
    //保留两位的四舍五入，获得含税单价
    let a3 = this.accDiv(Math.round(this.accMul(a2, 100)), 100);
    return a3;
}


//未税小计更新
function updateAmountExcludeTax(qty, unit_price) {
    //单价乘数量
    let a = this.accMul(unit_price, qty);
    //保留两位的四舍五入，获得未税小计
    let a2 = this.accDiv(Math.round(this.accMul(a, 100)), 100);
    return a2;
}

//税额小计
function updateAmountTax(qty, unit_price, tax_rate) {
    //税额小计a3=未税小计a1*税率a2
    let a1 = this.updateAmountExcludeTax(qty, unit_price);
    //获得税率
    let a2 = this.accDiv(tax_rate, 100);
    let a3 = this.accMul(a1, a2);
    //保留两位的四舍五入，获得税额小计
    let res = this.accDiv(Math.round(this.accMul(a3, 100)), 100);
    return res;
}

//税后小计价格更新
function updateTotalPrice(qty, unit_price, tax_rate) {
    //计算出含税的单价
    let a1 = this.updateUnitPriceInclueTax(unit_price, tax_rate);
    //使用含税单价*数量，获得含税总价。
    let a3 = this.accMul(a1, qty);
    //保留两位小数的四舍五入
    let a4 = this.accDiv(Math.round(this.accMul(a3, 100)), 100);
    return a4;
}

//下载文件
async function downloadFileWithFetch(file_url, file_name) {
    try {
        let res = await fetch(file_url);
        let blob = await res.blob();
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = url;
        link.download = file_name;
        document.body.appendChild(link);
        link.click();
        // 清理：释放Blob URL占用的内存  
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        return true;
    } catch (error) {
        console.error('下载失败:', error);
        return false;
    }
}

// 获取用户在header上选择的公司
function getOnCompanyOfUser() {
    let onCompanyId = 0;
    const storedCompany = localStorage.getItem('onCompany');
    const storedCompanyId = localStorage.getItem('onCompanyId');
    if (typeof store.state.onCompany === 'undefined') {
        onCompanyId = storedCompanyId;
        store.commit('setOnCompany', { 'onCompanyId': storedCompanyId, 'onCompany': storedCompany });
    } else {
        onCompanyId = store.state.onCompany.onCompanyId;
    }
    return Number(onCompanyId)
}

//获取采购订单的收货地址单一或多个的设置项
async function getPoSingleAddressValue(route) {
    let res = await dictObj.getTypes("po", "single_address", route);
    if (res.err === undefined) {
        let a = res.dictionary_infos;
        if (a.length === 1) {
            //有且仅有一条记录，返回该设置的值。
            return a[0].value;
        }
    } else {
        return false;
    }
}

//根据公司ID，获取其下的所有有效的库位列表
async function getAllWarehouseListByCompanyId(id) {
    //使用INTF-00193，获取公司详情
    let res = await orgObj.getOneFirmDetail(id);
    if (res.err === undefined) {
        //接口正常
        //使用INTF-00198，获得所有有效的库位列表，不分页
        let res2 = (await inventoryObj.getAllWarehouseList()).warehouse_infos;
        //从res中提取出当前公司下的工厂id数组，需要过滤出status===3并且is_active===1
        let factoryList = res.factory_infos.filter(item => item.status === 3 && item.is_active === 1);
        //从res2中，按照factoryList过滤出属于各个工厂的库位
        let res3 = [];
        factoryList.forEach(itemA => {
            // 使用filter从res2中筛选出id与当前itemA的id相等的元素  
            let filteredB = res2.filter(itemB => itemB.factory_id === itemA.id);
            // 将筛选出的元素添加到结果数组中  
            res3 = [...res3, ...filteredB];
        });
        return res3;
    } else {
        console.log("获取公司下的有效库位列表失败", res.msg);
        return false;
    }
}

//获取当前公司下的库位列表，不用传入公司id
async function getWarehouseInCurrentCompany(route) {
    //获取当前的公司id
    let companyId = getOnCompanyOfUser();
    //获取公司下的库位列表
    let res = await getAllWarehouseListByCompanyId(companyId);
    if (res !== false) {
        //获取成功
        return res;
    } else {
        //失败
        return false;
    }
}

//根据对象数组中的某个属性值，检查数组中的元素是否重复，有重复，返回true,否则返回false
function hasDuplicateByPropValue(arr, propString) {
    let namesSet = new Set();
    for (let obj of arr) {
        if (namesSet.has(obj[propString])) {
            // 如果Set中已经存在这个属性的值，说明有重复  
            return true;
        }
        namesSet.add(obj[propString]); // 否则，添加到Set中  
    }
    // 遍历完所有元素后，如果没有返回true，说明没有重复  
    return false;
}

//在str中，获取第一个mark后面的所有字符串内容
function getSubStrByMark(str, mark) {
    let i = str.indexOf(mark);
    if (i !== -1) {
        //有切分标记，对外输出标记后面的的内容
        let subStr = str.substring(i + 1);
        return subStr;
    } else {
        //没有标记，返回str
        return str;
    }
}

//根据value，在arr中按照value匹配，获取其name。value需要是string.
//用于从dictionary中，按照value取name使用
function getNameByValue(value, arr) {
    let a = arr.filter(item => item.value === value);
    if (a.length === 1) {
        return a[0].label;
    }
}

//日期格式转成字符串
function date2Str(sDate) {
    //将日期格式转成字符串
    let year = sDate.getFullYear();
    let month = String(sDate.getMonth() + 1).padStart(2, '0'); // 月份从0起始，需加1并补零  
    let day = String(sDate.getDate()).padStart(2, '0'); // 日期补零  
    // 将它们拼接成所需的字符串格式  
    let dateStr = `${year}-${month}-${day}`;
    return dateStr;
}

//计算str的n天前的日期，返回string
function getDateBeforeNDays(dateStr, n) {
    // 将字符串转换为 Date 对象  
    let sDate = new Date(dateStr);
    // 检查日期是否有效  
    if (isNaN(sDate.getTime())) {
        console.error("无效的日期字符串");
        return { res: false, msg: "无效的日期字符串" };
    } else {
        // 计算新的日期  
        sDate.setDate(sDate.getDate() - n);
        // 将新的日期转换回字符串格式（YYYY-MM-DD）  
        let newDate = this.date2Str(sDate);
        return { res: newDate, msg: "转换成功" };
    }
}

//根据提供的str，检查是否已有该批次/序列号，并返回是批次还是序列号信息
async function checkLotTypeByStr(str, trace_type) {
    //使用查询批次序列号列表的接口进行调取
    let query = { keyword1: "", keyword2: [{ id: 0, key: "name", operator: "equal", value: str }], limit: 50, offset: 0, type: 2 };
    //INTF-00077：获取分页的批次序列号列表
    let res = await inventoryObj.getTraceList(query);
    if (res.err === undefined) {
        let temp = res.trace_infos;
        if (temp.length === 1) {
            //有且仅有一条记录
            if (temp[0].type === trace_type) {
                //如果类型相同
                return 1;
            } else {
                return -1;
            }
        } else if (temp.length === 0) {
            //没有记录
            return 0;
        } else if (temp.length > 1) {
            //如果多条记录
            return -2;
        }
    } else {
        console.log("检查批次序列号信息失败", err);
        return -1;
    }
}

//检查obj是否是空对象，空对象返回true，非空返回false
function isEmptyObject(obj) {
    // 确保变量是对象且不为 null
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }

    // 使用 Object.keys 获取对象自身可枚举属性的键数组
    return Object.keys(obj).length === 0;
}


export default {
    formatToTime,
    setBody,
    setCookieParam,
    getMenuAuthByCache,
    getMenuAuthorityByPath, //历史使用
    perms2BtnAuth,
    setStartEndDate,
    getCurrentDate,
    getIndexById, //在arr中，查找元素对象的id===id的值，返回其index
    getUidAndToken,
    getAuthorityByRoute, //新使用
    isObjComplete,
    checkPurchaseQty, //根据最小起订量信息，检查采购订单行的数量是否符合规则
    checkSaleQty, //根据最小起售量、销售最小包装数，检查销售订单行的数量是否符合规则
    afterToday, //检查输入的字符串“YYYY-MM-DD"是否晚于等于当天
    accSub, //自定义减法
    accAdd, //自定义加法
    accMul, //自定义乘法
    accDiv, //自定义处除法
    hasDuplicatedStr, //检查数组中每个对象元素的str属性名，是否有相同的存在
    isAfterXDays, //检查当前日期加X天，是否超过了输入的date日期
    lookupComapnyFactory, //对库位名称拼接上对应的公司、工厂
    updateAmountExcludeTax, //根据输入的数量、单价，获得未税小计
    updateTotalPrice, //根据输入的数量、单价、税率，获得含税小计
    updateUnitPriceInclueTax, //根据输入的单价，税率，获得税后单价
    updateAmountTax, //根据输入的数量、单价、税率，获得税额小计
    downloadFileWithFetch, //使用Fetch方法下载文件
    getOnCompanyOfUser, // 获取用户在header上选择的公司
    getPoSingleAddressValue, //获取采购订单的收货地址单一或多个的设置项
    getAllWarehouseListByCompanyId, //根据传入的公司ID，获取其下有效的库位列表
    getWarehouseInCurrentCompany, //获取当前公司的库位列表
    hasDuplicateByPropValue, //根据某个属性值，查数组中是否有重复
    getSubStrByMark, //在str中，获取第一个mark后面的所有字符串内容
    getNameByValue, //用于从dictionary中，按照value取name使用
    date2Str, //日期格式转成字符串格式
    getDateBeforeNDays, //计算Date的N天前的日期
    checkLotTypeByStr, //检查批次序列号信息名称与已有数据是否一致
    isEmptyObject, //对象是否是空对象
}